export default {
  btnUnpause: {
    en: 'Unpause',
  },
  textUnpause: {
    en: `
    Unfortunately, your subscription is paused. Only active customers can downgrade their subscription.
    Please unpause your subscription.
  `,
  },
  btnUnpaid: {
    en: 'Update',
  },
  textUnpaid: {
    en: `
    Unfortunately, your subscription is not active due to the failed charge.
    Only active customers can downgrade their subscription.
    Please update your billing info and you automatically will be downgraded to a monthly subscription.
  `,
  },
}
